export default "__VITE_PUBLIC_ASSET__0d2217a9__"